// extracted by mini-css-extract-plugin
module.exports = {"max-path":"Graphs_max-path__iuzQE","max-points":"Graphs_max-points__P9krq","min-path":"Graphs_min-path__oIT6o","min-points":"Graphs_min-points__Q5l33"};